import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import useViewport from 'src/hooks/useViewport'
import { selectCustomerId } from 'src/store/selectors/customerProfile'
import {
  selectListing,
  selectSimilarListings,
} from 'src/store/selectors/listings'
import { fetchListing, fetchSimilarListings } from 'src/actions/listing'
import { fetchFavoriteListings } from 'src/actions/favoriteListings'
import { setActiveTab } from 'src/actions/navigation'
import { OverlayMask } from 'src/Components'
import { selectScheduleTourShowModal } from 'src/store/slices/scheduleTour'
import ScheduleTourWizard from './ScheduleTour/ScheduleTourWizard'
import MobileDetails from './MobileListingDetails'
import DesktopDetails from './DesktopListingDetails'
import PhotoPanel from './PhotoPanel'
import MapPanel from './MapPanel'
import styles from './ListingDetails.module.scss'
import { BotHeadSpinWithMessage } from 'src/Components'
import { FormattedMessage } from 'react-intl'

const ListingDetails = ({ match }) => {
  const customerId = useSelector(selectCustomerId)
  const { listingId } = match.params
  const dispatch = useDispatch()
  const { isMediumOrAbove } = useViewport()
  const listing = useSelector(selectListing)
  const similarListings = useSelector(selectSimilarListings)
  const showModal = useSelector(selectScheduleTourShowModal)

  useEffect(() => {
    dispatch(setActiveTab(null))
  }, [dispatch])

  useEffect(() => {
    if (customerId) {
      dispatch(fetchListing(customerId, listingId))
      dispatch(fetchSimilarListings(listingId, false))
      dispatch(fetchFavoriteListings(customerId))
    }
  }, [dispatch, customerId, listingId])

  const getListingDetailsOrLoading = () => {
    if (listing.loading) {
      return (
        <BotHeadSpinWithMessage className={styles.loadingContainer}>
          <FormattedMessage
            id='BotHeadSpinWithMessage.ListingDetails'
            defaultMessage='Loading home details...'
          />
        </BotHeadSpinWithMessage>
      )
    }
    if (!isMediumOrAbove) {
      return (
        <MobileDetails listing={listing} similarListings={similarListings} />
      )
    }
    if (isMediumOrAbove) {
      return (
        <DesktopDetails listing={listing} similarListings={similarListings} />
      )
    }
  }
  return (
    <>
      <PhotoPanel listing={listing} />
      <MapPanel listing={listing} />
      <OverlayMask isExact>
        <div className={styles.container}>{getListingDetailsOrLoading()}</div>
      </OverlayMask>
      {showModal && <ScheduleTourWizard />}
    </>
  )
}

ListingDetails.propTypes = {
  match: PropTypes.object,
}

export default ListingDetails
